export default "__VITE_ASSET__BhBAQfIl__"